import React, { createContext, useCallback, useContext, useEffect, useMemo, useReducer, useState } from "react";

// Phase 82 — panier du site public (persisté par site dans localStorage)
const CartCtx = createContext(null);
const keyOf = (productId, options = {}) => `${productId}::${JSON.stringify(Object.entries(options).sort())}`;

function reducer(state, action) {
  switch (action.type) {
    case "add": {
      const key = keyOf(action.item.product_id, action.item.options);
      const existing = state.find((i) => i.key === key);
      if (existing) return state.map((i) => (i.key === key ? { ...i, qty: Math.min(99, i.qty + (action.item.qty || 1)) } : i));
      return [...state, { ...action.item, key, qty: action.item.qty || 1 }];
    }
    case "qty": return state.map((i) => (i.key === action.key ? { ...i, qty: action.qty } : i)).filter((i) => i.qty > 0);
    case "remove": return state.filter((i) => i.key !== action.key);
    case "clear": return [];
    default: return state;
  }
}

export function CartProvider({ slug, children }) {
  const storageKey = `wsite-cart-${slug}`;
  const [items, dispatch] = useReducer(reducer, [], () => { try { return JSON.parse(localStorage.getItem(storageKey) || "[]"); } catch { return []; } });
  const [open, setOpen] = useState(false);
  useEffect(() => { try { localStorage.setItem(storageKey, JSON.stringify(items)); } catch { /* ignore */ } }, [items, storageKey]);

  const add = useCallback((item) => { dispatch({ type: "add", item }); setOpen(true); }, []);
  const value = useMemo(() => ({
    items, open, setOpen, add,
    setQty: (key, qty) => dispatch({ type: "qty", key, qty }),
    remove: (key) => dispatch({ type: "remove", key }),
    clear: () => dispatch({ type: "clear" }),
    count: items.reduce((n, i) => n + i.qty, 0),
    subtotal: items.reduce((n, i) => n + i.qty * Number(i.price || 0), 0),
  }), [items, open, add]);
  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export function useCart() {
  return useContext(CartCtx) || { items: [], count: 0, subtotal: 0, open: false, setOpen: () => {}, add: () => {}, setQty: () => {}, remove: () => {}, clear: () => {} };
}
